import { FC, ReactNode } from 'react'

import * as RadixSwitch from '@radix-ui/react-switch'
import { styled } from 'styled-components'

type SwitchProps = {
  checked: boolean
  disabled?: boolean
  id?: string
  name?: string
  className?: string
  label?: ReactNode
  onCheckedChange: (checked: boolean) => void
}

const Switch: FC<SwitchProps> = ({
  checked,
  disabled,
  id,
  name,
  className,
  label,
  onCheckedChange,
}) => {
  return (
    <Container className={className}>
      <StyledRoot
        checked={checked}
        disabled={disabled}
        id={id}
        name={name}
        onCheckedChange={onCheckedChange}
      >
        <StyledThumb />
      </StyledRoot>
      {label && <Label htmlFor={id}>{label}</Label>}
    </Container>
  )
}

export default Switch

const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
`

const StyledRoot = styled(RadixSwitch.Root)`
  all: unset;
  position: relative;
  -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
  border-radius: 9999px;
  background-color: ${(p) => p.theme.surfaceDim};
  cursor: pointer;
  width: 32px;
  height: 18px;

  &[data-state='checked'] {
    background-color: ${(p) => p.theme.primary};
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const StyledThumb = styled(RadixSwitch.Thumb)`
  display: block;
  transform: translate(1px, 0);
  transition: transform 100ms;
  border-radius: 9999px;
  background-color: white;
  width: 16px;
  height: 16px;
  will-change: transform;

  &[data-state='checked'] {
    transform: translate(15px, 0);
  }
`

const Label = styled.label`
  cursor: pointer;
  color: ${(p) => p.theme.text};
  font-size: 14px;
  user-select: none;
`
